var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgQuestionMarker = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 45 52",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.0137 35.2366L37.0025 35.2475L36.9914 35.2586L22.5 49.8699L8.00858 35.2586L7.99754 35.2475L7.98626 35.2366C5.1229 32.4678 3.17895 28.9465 2.39195 25.1206C1.60503 21.2952 2.00844 17.3295 3.5535 13.7227C5.09883 10.1153 7.71932 7.02376 11.0915 4.84501C14.4642 2.66594 18.4345 1.5 22.5 1.5C26.5655 1.5 30.5358 2.66594 33.9085 4.84501C37.2807 7.02376 39.9012 10.1153 41.4465 13.7227C42.9916 17.3295 43.395 21.2952 42.608 25.1206C41.8211 28.9465 39.8771 32.4678 37.0137 35.2366Z",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23 32.5C23 32.7761 22.7761 33 22.5 33C22.2239 33 22 32.7761 22 32.5C22 32.2239 22.2239 32 22.5 32C22.7761 32 23 32.2239 23 32.5Z",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 27V25.375C23.5878 25.375 24.6512 25.0414 25.5556 24.4165C26.4601 23.7915 27.1651 22.9033 27.5813 21.864C27.9976 20.8248 28.1065 19.6812 27.8943 18.5779C27.6821 17.4747 27.1583 16.4612 26.3891 15.6658C25.6199 14.8704 24.6399 14.3287 23.573 14.1093C22.5061 13.8898 21.4002 14.0025 20.3952 14.4329C19.3902 14.8634 18.5313 15.5924 17.9269 16.5277C17.3226 17.463 17 18.5626 17 19.6875",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgQuestionMarker);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/question-marker.94cad6de884b38f64c65b46dd183abe5.svg";